import "../../Styles/Common/JsonTextArea.scss";

const JsonTextArea = ({
  handlecustomAttributesChange,
  label,
  customAttributes,
  placeholder,
  handleFormatJson,
  name,
  className,
  expandModal,
  icon,
}) => {
  return (
    <div className="jsontextarea">
      <div className="form-group form-field form-field-details">
        <label>
          {label}
        </label>
        <textarea
          placeholder={placeholder}
          className={`${className} label-bg-details customAttributeBox`}
          name={name}
          style={{
            overflowX: "hidden", // no horizontal scrollbar
            overflowY: "auto", // only vertical scroll
            minHeight: "150px",
            height: '150px'
          }}
          required
          onChange={handlecustomAttributesChange}
          onBlur={handlecustomAttributesChange}
          wrap="soft" // allows word wrapping
          value={customAttributes}
        />
      </div>
      <div className="formatJsonBtn">
        <button onClick={handleFormatJson} className="formatbtn">
          Format JSON
        </button>
        <button className="expandIcon" onClick={expandModal}>
          <img src={icon} alt="expand" />
        </button>
      </div>
    </div>
  );
};

export default JsonTextArea;
